import { render, staticRenderFns } from "./LibraryDetail.vue?vue&type=template&id=395857bb&"
import script from "./LibraryDetail.vue?vue&type=script&lang=js&"
export * from "./LibraryDetail.vue?vue&type=script&lang=js&"
import style0 from "./LibraryDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports